import LocationOnIcon from '@mui/icons-material/LocationOn'

export default {
  name: 'vehicle-telematics',
  options: { defaultSort: { field: 'started_on', order: 'ASC' } },
  icon: LocationOnIcon,
}
